var React = require("react");
var component;
var desc = {
	loadComponent: function(callback) {
		if(!component) {
			require.ensure([], function() {
				component = require("!!../../node_modules/react-proxy-loader/index.js!../../node_modules/babel-loader/lib/index.js??ref--1!./LoginPage.jsx");
				if(callback) callback(component);
			}, "LoginPage");
		} else if(callback) callback(component);
		return component;
	},
};
var mixinReactProxy = require("../../node_modules/react-proxy-loader/mixinReactProxy.js");
mixinReactProxy(React, desc);
module.exports = React.createClass(desc);
module.exports.Mixin = desc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-proxy-loader?name=LoginPage!./src/pages/LoginPage.jsx
// module id = 301
// module chunks = 58